import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { orange } from '@mui/material/colors'
import { useTranslation } from 'react-i18next'

import Accordion from 'components/Participants/Group/ProjectsInGroup/Accordion'
import { useAppSelector } from 'redux/Hook'

const ProjectsInGroup = () => {
  const { t } = useTranslation()
  const { projectsInAGroup } = useAppSelector(
    (state) => state.participantGroups,
  )

  const Component = (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ py: '0.625rem' }}>
        <Box component="span">
          {t('filters.participantGroup.projectsInGroup')}:
          <Box component="span" color={orange[900]}>
            &nbsp;{projectsInAGroup.length} {t('common.projects')}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {projectsInAGroup.map((project, index) => (
          <Typography key={index}>{project.name}</Typography>
        ))}
      </AccordionDetails>
    </Accordion>
  )

  return projectsInAGroup.length ? Component : <></>
}

export default ProjectsInGroup
